import { extendTheme } from '@chakra-ui/react';
import {
  BG_ALTERNATIVE,
  BG_LAYER,
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: FONT_FAMILY.heading,
    subHeading: FONT_FAMILY.subHeading,
    body: FONT_FAMILY.body,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '70px',
    subHeading: '20px',
    body: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    body: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    backgroundAssetColor: BG_LAYER,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
  breakpoints: {
    base: '0em', // 0px
    xs: '360px', // Galaxy S8
    xp: '390px', // Iphone Pro
    xr: '410px', // Iphone XR
    lg: '480px',
    sm: '480px',
    md: '500px',
  },
};

export default extendTheme(theme);
